const i18nConfig = {
  defaultLocale: 'en',
  locales: ['en'],
  defaultNS: 'common'
};

export default i18nConfig;
